var map = {
	"./Black_Account_Icons-01.png": 678,
	"./Black_Account_Icons-02.png": 679,
	"./Black_Account_Icons-03.png": 680,
	"./Black_Account_Icons-04.png": 681,
	"./Black_Account_Icons-05.png": 682,
	"./Black_Account_Icons-06.png": 683,
	"./Black_Account_Icons-07.png": 684,
	"./Black_Account_Icons-08.png": 685,
	"./Black_Account_Icons-09.png": 686,
	"./Black_Account_Icons-10.png": 687,
	"./Black_Account_Icons-11.png": 688,
	"./Black_Account_Icons-12.png": 689,
	"./Black_Account_Icons-13.png": 690,
	"./Black_Account_Icons-14.png": 691,
	"./FilePresentOutlined.svg": 692,
	"./accuracyAccountsDemo_downloadMT4.jpg": 693,
	"./accuracyAccountsReal_downloadMT4.jpg": 694,
	"./alert@2x.svg": 695,
	"./apple-brands.svg": 696,
	"./arrow_up_from_box.svg": 697,
	"./bankWire.svg": 698,
	"./bdswissDemo_downloadMT4.png": 699,
	"./bdswissGlobalDemo_downloadMT4.png": 700,
	"./bdswissGlobalReal02_downloadMT4.png": 701,
	"./bdswissGlobalReal03_downloadMT4.png": 702,
	"./bdswissGlobalReal04_downloadMT4.png": 703,
	"./bdswissGlobalReal05_downloadMT4.png": 704,
	"./bdswissGlobalReal_downloadMT4.png": 705,
	"./bdswissGlobalReal_downloadMT5.png": 706,
	"./bdswissReal02_downloadMT4.png": 707,
	"./bdswissReal03_downloadMT4.png": 708,
	"./bdswissReal04_downloadMT4.png": 709,
	"./bdswissReal05_downloadMT4.png": 710,
	"./bdswissReal_downloadMT4.png": 711,
	"./bdswissReal_downloadMT5.png": 712,
	"./bdswissSCDemo_downloadMT4.png": 713,
	"./bdswissSCReal01_downloadMT4.png": 714,
	"./bdswissSCReal02_downloadMT4.png": 715,
	"./bdswissSCReal03_downloadMT4.png": 716,
	"./bdswissSCReal04_downloadMT4.png": 717,
	"./bdswissSCReal05_downloadMT4.png": 718,
	"./bdswiss_grey.png": 719,
	"./bdswiss_white.png": 720,
	"./bg-image-affiliate.png": 721,
	"./bitwallet-bdSwiss-dark.svg": 722,
	"./bitwallet-bdSwiss-light.svg": 723,
	"./bitwallet-swissMarkets-dark.svg": 724,
	"./bitwallet-swissMarkets-light.svg": 725,
	"./card.svg": 726,
	"./check_circle.png": 727,
	"./chf.png": 728,
	"./competitions.png": 729,
	"./complimentary@2x.svg": 730,
	"./control-radio-off.png": 731,
	"./control-radio-on.png": 732,
	"./crypto.svg": 733,
	"./cvv.svg": 734,
	"./deposit-card.svg": 735,
	"./diners.png": 736,
	"./dkk.png": 737,
	"./document-upload-failure-dark.png": 738,
	"./document-upload-failure-light.png": 739,
	"./document-upload-success-black.png": 740,
	"./document-upload-success-dark.png": 741,
	"./document-upload-success-light.png": 742,
	"./documents-empty-dark.png": 743,
	"./documents-empty-light.png": 744,
	"./downloadPdf-light.png": 745,
	"./downloadPdf.png": 746,
	"./dpWorldTourChampionship-dark.svg": 747,
	"./dpWorldTourChampionship-light.svg": 748,
	"./eWallet.svg": 749,
	"./eur.png": 750,
	"./exp-date.svg": 751,
	"./fees@2x.svg": 752,
	"./filterIcon.png": 753,
	"./gbp.png": 754,
	"./icon-add-account.svg": 448,
	"./icon-appstore@2x.png": 755,
	"./icon-arrow-right-dark.png": 756,
	"./icon-arrow-right-light.png": 757,
	"./icon-bank-wire.svg": 758,
	"./icon-checkbox.svg": 759,
	"./icon-close-dark.svg": 760,
	"./icon-close-light.svg": 761,
	"./icon-close.png": 762,
	"./icon-contact-callback@2x.png": 763,
	"./icon-contact-callback@2x.svg": 764,
	"./icon-contact-chat@2x.png": 449,
	"./icon-contact-chat@2x.svg": 450,
	"./icon-contact-email@2x.png": 765,
	"./icon-contact-email@2x.svg": 766,
	"./icon-contact-faqs@2x.png": 767,
	"./icon-contact-faqs@2x.svg": 768,
	"./icon-contact-oneOnOneSession@2x.png": 769,
	"./icon-contact-telegram@2x.png": 770,
	"./icon-contact-whatsapp@2x.png": 771,
	"./icon-crypto.svg": 772,
	"./icon-document.svg": 773,
	"./icon-facebook@2x.png": 774,
	"./icon-google-play@2x.png": 775,
	"./icon-notification.svg": 776,
	"./icon-profile-big.svg": 777,
	"./icon-profile.svg": 778,
	"./icon-spoa.svg": 779,
	"./icon-swapFree.svg": 780,
	"./icon-telegram@2x.png": 781,
	"./icon-twitter@2x.png": 782,
	"./icon_accounts_dashboard.svg": 783,
	"./icon_logout_dashboard.svg": 784,
	"./icon_notification_dashboard.svg": 785,
	"./icon_profilesettings_dashboard.svg": 786,
	"./icon_support_dashboard.svg": 787,
	"./icon_transaction_dashboard.svg": 788,
	"./jcb.png": 789,
	"./knet-logo.png": 451,
	"./languages.png": 790,
	"./limit-failure-dark.png": 791,
	"./limit-failure-light.png": 792,
	"./logo-accuracy.png": 793,
	"./logo-bdstrading-white.svg": 794,
	"./logo-bdstrading.svg": 795,
	"./logo-bdswiss-white.svg": 796,
	"./logo-bdswiss.png": 797,
	"./logo-bdswiss.svg": 798,
	"./logo-equityflow-black.png": 799,
	"./logo-equityflow-white.png": 800,
	"./logo-facebook.png": 801,
	"./logo-google.png": 802,
	"./logo-google.svg": 803,
	"./logo-lydian-black.png": 804,
	"./logo-lydian-black.svg": 805,
	"./logo-lydian-white.svg": 806,
	"./logo-regalx-white.png": 807,
	"./logo-regalx.png": 808,
	"./logo-skyground-black.svg": 809,
	"./logo-skyground-white.svg": 810,
	"./logo-swissmarkets-white.svg": 811,
	"./logo-swissmarkets.png": 812,
	"./logo-swissmarkets.svg": 813,
	"./logo-tauromarkets-black.png": 814,
	"./logo-tauromarkets-white.png": 815,
	"./logo-tauromarkets-white2.png": 816,
	"./logo-tauromarkets-white2.svg": 817,
	"./logo-valutamarkets.png": 818,
	"./maestro.png": 819,
	"./mastercard.png": 820,
	"./mastercard_logo_icon.svg": 821,
	"./mercedesCup-dark.svg": 822,
	"./mercedesCup-light.svg": 823,
	"./nationalIdBR.png": 824,
	"./nationalIdES.jpg": 825,
	"./nationalIdIT.jpg": 826,
	"./nationalIdZA.png": 827,
	"./no-trades-dark.png": 828,
	"./no-trades-light.png": 829,
	"./no-trading-signals-dark.png": 830,
	"./nok.png": 831,
	"./notifications-empty-dark.png": 832,
	"./notifications-empty-light.png": 833,
	"./onlineBanking.svg": 834,
	"./onlineDeposit.svg": 835,
	"./page-not-found-dark.svg": 452,
	"./page-not-found-light.svg": 453,
	"./payment-failure-dark.png": 836,
	"./payment-failure-light.png": 837,
	"./payment-pending-dark.png": 838,
	"./payment-pending-light.png": 839,
	"./payment-success-dark.png": 840,
	"./payment-success-light.png": 841,
	"./payments-history-empty-dark.png": 842,
	"./payments-history-empty-light.png": 843,
	"./phone_verification.png": 844,
	"./place1-leadership.png": 845,
	"./place2-leadership.png": 846,
	"./place3-leadership.png": 847,
	"./pln.png": 848,
	"./pof-bankStatement.png": 849,
	"./pof-bankStatementPOF.png": 850,
	"./pof-card-back.png": 851,
	"./pof-card.png": 852,
	"./pof-cardStatement.png": 853,
	"./pof-other.png": 854,
	"./pof-proofOfResidence.png": 855,
	"./pof-swiftCopyPaymentAdvice.png": 856,
	"./pof-virtualCard.png": 857,
	"./poi-document.png": 858,
	"./poi-drivingLicense-back.png": 859,
	"./poi-drivingLicense.png": 860,
	"./poi-id-back.png": 861,
	"./poi-id.png": 862,
	"./poi-passport.png": 863,
	"./por-bankStatementPOR.png": 864,
	"./por-document.png": 865,
	"./por-proofOfResidence.png": 866,
	"./por-utilityBill.png": 867,
	"./priority@2x.svg": 868,
	"./referAndEarn.png": 869,
	"./regalxDemo_downloadMT4.png": 870,
	"./regalxReal01_downloadMT4.png": 871,
	"./regalxReal02_downloadMT4.png": 872,
	"./regalxReal03_downloadMT4.png": 873,
	"./regalxReal04_downloadMT4.png": 874,
	"./regalxReal05_downloadMT4.png": 875,
	"./register-referral-light.png": 876,
	"./sek.png": 877,
	"./sign-up.png": 878,
	"./spaceship.png": 879,
	"./spreads@2x.svg": 880,
	"./support@2x.svg": 881,
	"./swissmarketsDemo_downloadMT4.png": 882,
	"./swissmarketsReal02_downloadMT4.png": 883,
	"./swissmarketsReal_downloadMT4.png": 884,
	"./tauroDemo01DownloadMT4.jpg": 885,
	"./tauroReal01DownloadMT4.jpg": 886,
	"./technicalIndicator-ebook.png": 887,
	"./technicalIndicatorItem.svg": 888,
	"./telegram-dark.png": 889,
	"./telegram.png": 890,
	"./trading-alerts-tradingAlerts-dark.png": 891,
	"./trading-alerts-tradingAlerts-light.png": 892,
	"./tradingPsychology-ebook.png": 893,
	"./tradingPsychologyItem.svg": 894,
	"./transfer-external.svg": 895,
	"./transfer-internal.svg": 896,
	"./transfer-spoa.svg": 897,
	"./upload-bankStatement-error.png": 898,
	"./upload-bankStatement-success.png": 899,
	"./upload-bankStatement.png": 900,
	"./upload-document-dark.png": 901,
	"./upload-document-light.png": 902,
	"./upload-generic-error.png": 903,
	"./upload-generic-success.png": 904,
	"./upload-generic.png": 905,
	"./upload-pof-back-card-error.png": 906,
	"./upload-pof-back-card-success.png": 907,
	"./upload-pof-back-card.png": 908,
	"./upload-pof-front-card-error.png": 909,
	"./upload-pof-front-card-success.png": 910,
	"./upload-pof-front-card.png": 911,
	"./upload-poi-back-drivingLicense-error.png": 912,
	"./upload-poi-back-drivingLicense-success.png": 913,
	"./upload-poi-back-drivingLicense.png": 914,
	"./upload-poi-back-error.png": 915,
	"./upload-poi-back-success.png": 916,
	"./upload-poi-back.png": 917,
	"./upload-poi-front-drivingLicense-error.png": 918,
	"./upload-poi-front-drivingLicense-success.png": 919,
	"./upload-poi-front-drivingLicense.png": 920,
	"./upload-poi-front-error.png": 921,
	"./upload-poi-front-success.png": 922,
	"./upload-poi-front.png": 923,
	"./upload-por-front-error.png": 924,
	"./upload-por-front-proofOfResidence-error.png": 925,
	"./upload-por-front-proofOfResidence-success.png": 926,
	"./upload-por-front-proofOfResidence.png": 927,
	"./upload-por-front-success.png": 928,
	"./upload-por-front-utilityBill-error.png": 929,
	"./upload-por-front-utilityBill-success.png": 930,
	"./upload-por-front-utilityBill.png": 931,
	"./upload-por-front.png": 932,
	"./usd.png": 933,
	"./visa.png": 934,
	"./visa_logo_icon.svg": 935,
	"./vps-enter-credentials.png": 936,
	"./vps-remote-desktop-windows.png": 937,
	"./vps-remote-desktop.png": 938,
	"./waiting-list-skip-dark.png": 939,
	"./waiting-list-skip.png": 940,
	"./windows-brands.svg": 941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1349;